// Centralised status→pastel palette. Same status renders the same colour everywhere.
const PASTELS = [
  { bg: "#E9F5EE", fg: "#175E33" }, // green
  { bg: "#FFE9E0", fg: "#7A2B00" }, // peach
  { bg: "#E7EEFF", fg: "#1F3A8A" }, // blue
  { bg: "#FFF4C9", fg: "#5A4700" }, // gold
  { bg: "#F3E7FF", fg: "#4B1E7A" }, // violet
  { bg: "#DFF5F5", fg: "#0F5B5B" }, // teal
  { bg: "#FFE2EC", fg: "#7A1A3A" }, // pink
  { bg: "#EAF8D6", fg: "#345800" }, // lime
  { bg: "#FFEBD0", fg: "#7A4800" }, // amber
];

const KNOWN = {
  // Projects
  "Planned": PASTELS[2], "Active": PASTELS[0], "In Progress": PASTELS[2],
  "On Hold": PASTELS[4], "Completed": PASTELS[0], "Cancelled": PASTELS[1],
  // Work orders
  "Assigned": PASTELS[2], "Submitted": PASTELS[3], "Reassigned": PASTELS[1], "Overdue": PASTELS[1],
  // Payments
  "Pending": PASTELS[3], "Partially Paid": PASTELS[8], "Processed": PASTELS[0], "Paid": PASTELS[0],
  // Tickets
  "Open": PASTELS[3], "Closed": PASTELS[0], "Rejected": PASTELS[1], "Approved": PASTELS[0],
  // User
  "Active": PASTELS[0], "invited": PASTELS[3], "deactivated": PASTELS[1],
  "Online": PASTELS[0], "Away": PASTELS[3], "Offline": PASTELS[1],
};

function hash(str) { let h = 0; for (let i = 0; i < (str || "").length; i++) h = ((h << 5) - h) + str.charCodeAt(i) | 0; return Math.abs(h); }

export function statusPalette(name) {
  if (!name) return { bg: "#F5F5F5", fg: "#555" };
  if (KNOWN[name]) return KNOWN[name];
  return PASTELS[hash(name) % PASTELS.length];
}

export function StatusBadge({ status, testid, size = "sm" }) {
  const { bg, fg } = statusPalette(status);
  const pad = size === "lg" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[11px]";
  return (
    <span data-testid={testid} className={`inline-block ${pad} font-mono-tight uppercase tracking-wide rounded-full border border-black/5`} style={{ background: bg, color: fg }}>
      {status || "—"}
    </span>
  );
}
